import {
    defineStore,
} from 'pinia'
import {
    useContextStore,
} from '~~/stores/context'
import { PROVIDERS } from '#shared/providers'

export const useBurnerMailStore = defineStore('burner-mail', () => {
    const PROVIDER = PROVIDERS.BURNER_MAIL

    const burners = ref([])

    const contextStore = useContextStore()
    contextStore.registerProvider(PROVIDER)

    const ctx = computed(() => contextStore.getContext(PROVIDER))
    watch(ctx, (newCtx, oldCtx) => {
        if (newCtx?.identityKey !== oldCtx?.identityKey) {
            burners.value = []
        }
    })

    async function fetchBurners() {
        useRequest({
            label: `fetch burner mail burners`,
            fetch: () => $fetch('/api/burner-mail/burners', {
                method: 'GET',
            }),
            evaluate: ({ burners: b }) => [...b],
            store: (b) => burners.value = b,
            successDetails: (b) => b.length,
        })
    }

    function init() {}

    return {
        burners,
        fetchBurners,
        init,
    }
})
